export * from "./types.js";
export * from "./copy.js";
export {
  deriveIncomeTests,
  deriveIncome,
  incomeForSurchargePurposes,
  helpRepaymentIncome,
  div293Income,
  adjustedTaxableIncome,
  adjustedFringeBenefitsTotal,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { IncomeTestsRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/** Registry of income-tests rulesets by financial year. Historical years stay
 * registered so re-runs/amendments resolve against the FBT rate in force. */
export const INCOME_TESTS_RULESETS: Record<string, IncomeTestsRuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the income-tests ruleset for a financial year, or throw if unknown. */
export function incomeTestsRulesFor(fy: FinancialYear): IncomeTestsRuleSet {
  const rules = INCOME_TESTS_RULESETS[fy];
  if (!rules) {
    throw new Error(`no income-tests ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent income-tests ruleset — the default for live "this year" calcs. */
export const INCOME_TESTS_CURRENT_FY: FinancialYear = "2025-26";
